import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DiagnosticProvider } from "@/context/DiagnosticContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import PathwaySelect from "@/pages/PathwaySelect";
import AboutYou from "@/pages/AboutYou";
import Diagnostic from "@/pages/Diagnostic";
import Analysing from "@/pages/Analysing";
import Results from "@/pages/Results";
import Admin from "@/pages/Admin";

function App() {
  return (
    <DiagnosticProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pathway" element={<PathwaySelect />} />
          <Route path="/about" element={<AboutYou />} />
          <Route path="/diagnostic" element={<Diagnostic />} />
          <Route path="/analysing" element={<Analysing />} />
          <Route path="/results/:id" element={<Results />} />
          <Route path="/r/:token" element={<Results />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </DiagnosticProvider>
  );
}

export default App;
